<template>
  <span id="opcoesNotificacoes">
    <v-flex>
      <article class="notifi_email">
        <v-layout row wrap align-center justify-center fill-height class="dark--text">
          <v-fade-transition leave-absolute>
            <v-flex xs12 class>
              <h3 class="text-xs-center">Opções das notificações por e-mail:</h3>
            </v-flex>
          </v-fade-transition>
        </v-layout>
        <v-fade-transition leave-absolute>
          <v-layout row wrap>
            <!-- <v-flex xs4>
                              <v-switch
                                label="Resumo diário"
                                color="success"
                                v-model="opcoes.resumoDiario"
                              ></v-switch>
            </v-flex>-->
            <!-- <v-flex xs4>
                              <v-switch
                                label="Resumo semanal"
                                color="success"
                                v-model="opcoes.resumoSemanal"
                              ></v-switch>
            </v-flex>-->
            <v-flex xs4>
              <v-switch
                label="Novo Fornecedor"
                color="success"
                v-model="opcoes.novoFornecedor"
              ></v-switch>
            </v-flex>
            <v-flex xs4>
              <v-switch
                label="Novo Cliente"
                color="success"
                v-model="opcoes.novoCliente"
              ></v-switch>
            </v-flex>
            <v-flex xs4>
              <v-switch
                label="Notas Canceladas"
                color="success"
                v-model="opcoes.notaCancelada"
              ></v-switch>
            </v-flex>
            <v-flex xs4>
              <v-switch label="Nova NF-e" color="success" v-model="opcoes.nvNotaNfe"></v-switch>
            </v-flex>
            <v-flex xs4>
              <v-switch label="Nova CT-e" color="success" v-model="opcoes.nvNotaCte"></v-switch>
            </v-flex>
            <v-flex xs4>
              <v-switch label="Nova NFS-e" color="success" v-model="opcoes.nvNotaNfse"></v-switch>
            </v-flex>
            <!-- <v-flex xs4>
                              <v-switch
                                label="Vencimento da Nota Fiscal - eletrônica (NF-e)"
                                color="success"
                                v-model="notificacoes.email.vencimentoNF"
                              ></v-switch>
            </v-flex>-->
          </v-layout>
        </v-fade-transition>
      </article>
    </v-flex>
  </span>
</template>

<script>
export default {
  props: ['notificacoes', 'opcoes'],
  data: () => ({}),
  watch: {},
  methods: {
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/conta/empresa/formEmpresa/tabNotificacoes/opcoes/Opcoes.vue